var _g;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgDiscapacitados = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "87px",
    height: "87px",
    viewBox: "0 0 87 87",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Salida-datos",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "inicio-selecci\\xF3n-multiple-de-eventos-copy-19",
    transform: "translate(-1150.000000, -125.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(1150.000000, 125.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "wheelchair",
    transform: "translate(26.000000, 22.000000)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-14",
    fill: "#39B8CD",
    opacity: 0.645693824,
    cx: 43.5,
    cy: 43.5,
    r: 43.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.5006033,31 C44.9831187,31 47,28.9852727 47,26.5000464 C47,24.0140775 44.9831187,22 42.5006033,22 C40.0152107,22 38,24.0140775 38,26.5000464 C38,28.9852727 40.0152107,31 42.5006033,31 Z",
    id: "XMLID_31_",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.9969287,55.3404387 C47.8252225,59.3044871 44.0746348,62.2156683 39.634011,62.2156683 C34.2565134,62.2156683 29.8833744,57.9544846 29.8833744,52.7164676 C29.8833744,48.8390872 32.2840852,45.501832 35.710164,44.0271443 L35.710164,40 C30.0994711,41.6466061 26,46.7213893 26,52.7164676 C26,60.0406346 32.1161009,66 39.6339201,66 C45.1125539,66 49.8347582,62.8273965 52,58.2752808 L50.4605838,55.328298 C50.0284813,55.3317541 49.5278936,55.336185 48.9969287,55.3404387 Z",
    id: "XMLID_30_",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.7147265,60.2517668 L55.7656846,48.6888123 C55.3216524,47.8236195 54.4240606,47.2790361 53.4421879,47.2790361 L45.8227349,47.2790361 L45.8227349,45.5613299 L52.38034,45.5613299 C53.0351661,45.5613299 53.5855571,45.2229691 53.9410943,44.7355339 C54.172134,44.4180037 54.3364818,44.0491216 54.3364818,43.627348 C54.3364818,42.5596459 53.4617008,41.6936379 52.38034,41.6936379 L48.429672,41.6936379 L45.8227349,41.6936379 L45.8227349,35.8676014 C45.8227349,34.2652783 44.620999,32 41.9120087,32 C39.7514857,32 38,33.7318348 38,35.8676014 L38,48.4901975 C38,50.6690743 39.7866638,52.4354154 41.9907015,52.4354154 L49.1605341,52.4354154 L51.8432324,52.4354154 L57.0671835,62.5895898 C57.5262397,63.4839455 58.4423366,64 59.393062,64 C59.7915642,64 60.1956545,63.9099757 60.5732697,63.718878 C61.8589201,63.0742174 62.3695525,61.520982 61.7147265,60.2517668 Z",
    id: "XMLID_29_",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgDiscapacitados, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Discapacitados.a1f732f7.svg";
export { ForwardRef as ReactComponent };